import { z } from 'zod';

import { APPLICATION_STATUSES, type ApplicationStatus } from '@/shared/model/enums';

import { mapCoverageRequest, type CoverageRequest } from './coverage-request';

export interface CoverageApplication {
  readonly id: string;
  readonly requestId: string;
  readonly providerId: string;
  readonly message: string | null;
  readonly status: ApplicationStatus;
  readonly createdAt: string;
  readonly providerName: string | null;
  readonly providerCity: string | null;
  readonly request: CoverageRequest | null;
  // Phase 3 attendance
  readonly checkedInAt: string | null;
  readonly checkinVerified: boolean | null;
  readonly checkedOutAt: string | null;
  readonly checkoutVerified: boolean | null;
  readonly needsReview: boolean;
}

const applicationRowSchema = z.object({
  id: z.string(),
  request_id: z.string(),
  provider_id: z.string(),
  message: z.string().nullable(),
  status: z.enum(APPLICATION_STATUSES),
  created_at: z.string(),
  checked_in_at: z.string().nullable().optional(),
  checkin_verified: z.boolean().nullable().optional(),
  checked_out_at: z.string().nullable().optional(),
  checkout_verified: z.boolean().nullable().optional(),
  needs_review: z.boolean().optional(),
  profiles: z.object({ full_name: z.string(), city: z.string().nullable() }).nullable().optional(),
  coverage_requests: z.unknown().optional(),
});

export function mapCoverageApplication(row: unknown): CoverageApplication {
  const r = applicationRowSchema.parse(row);
  return {
    id: r.id,
    requestId: r.request_id,
    providerId: r.provider_id,
    message: r.message,
    status: r.status,
    createdAt: r.created_at,
    providerName: r.profiles?.full_name ?? null,
    providerCity: r.profiles?.city ?? null,
    request: r.coverage_requests != null ? mapCoverageRequest(r.coverage_requests) : null,
    checkedInAt: r.checked_in_at ?? null,
    checkinVerified: r.checkin_verified ?? null,
    checkedOutAt: r.checked_out_at ?? null,
    checkoutVerified: r.checkout_verified ?? null,
    needsReview: r.needs_review ?? false,
  };
}
